import z from "zod";

export const AddMemberSchema = z.object({
  users: z
    .array(
      z.object({
        label: z.string().nullable().optional(),
        value: z.number(),
      }),
      { message: "この項目は必須です。" }
    ) // { label: string; value: string }の形状を許可
    .min(1, "少なくとも1人のメンバーを選択してください"),
});

export type AddMemberFormData = z.infer<typeof AddMemberSchema>;
